import { useState, useCallback, useRef } from 'react';
import { Heart, Star, Play, Copy, Check, ExternalLink, Sparkles, Gift } from 'lucide-react';
import confetti from 'canvas-confetti';
import { SURPRISE, MY_NAME } from '@/config/valentineContent';

/* Brand icons */
function DiscordIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
      <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419 0-1.333.956-2.419 2.157-2.419 1.21 0 2.176 1.096 2.157 2.42 0 1.333-.947 2.418-2.157 2.418z" />
    </svg>
  );
}

function SpotifyIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z" />
    </svg>
  );
}

function SteamIcon({ size = 20 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor">
      <path d="M11.979 0C5.678 0 .511 4.86.022 11.037l6.432 2.658c.545-.371 1.203-.59 1.912-.59.063 0 .125.004.188.006l2.861-4.142V8.91c0-2.495 2.028-4.524 4.524-4.524 2.494 0 4.524 2.031 4.524 4.527s-2.03 4.525-4.524 4.525h-.105l-4.076 2.911c0 .052.004.105.004.159 0 1.875-1.515 3.396-3.39 3.396-1.635 0-3.016-1.173-3.331-2.727L.436 15.27C1.862 20.307 6.486 24 11.979 24c6.627 0 11.999-5.373 11.999-12S18.605 0 11.979 0zM7.54 18.21l-1.473-.61c.262.543.714.999 1.314 1.25 1.297.539 2.793-.076 3.332-1.375.263-.63.264-1.319.005-1.949s-.75-1.121-1.377-1.383c-.624-.26-1.29-.249-1.878-.03l1.523.63c.956.4 1.409 1.5 1.009 2.455-.397.957-1.497 1.41-2.454 1.012H7.54zm11.415-9.303c0-1.662-1.353-3.015-3.015-3.015-1.665 0-3.015 1.353-3.015 3.015 0 1.665 1.35 3.015 3.015 3.015 1.663 0 3.015-1.35 3.015-3.015zm-5.273-.005c0-1.252 1.013-2.266 2.265-2.266 1.249 0 2.266 1.014 2.266 2.266 0 1.251-1.017 2.265-2.266 2.265-1.253 0-2.265-1.014-2.265-2.265z" />
    </svg>
  );
}

const BRAND_ICONS = { nitro: DiscordIcon, spotify: SpotifyIcon, steam: SteamIcon };

/* ─── Small gift card (Discord / Spotify / Steam) ─── */
function SmallGiftCard({ gift, index }) {
  const [flipped, setFlipped] = useState(false);
  const [copied, setCopied] = useState(false);
  const BrandIcon = BRAND_ICONS[gift?.id] || (() => <Gift size={22} />);

  const handleCopy = async (e) => {
    e.stopPropagation();
    if (!gift?.code) return;
    try {
      await navigator.clipboard.writeText(gift.code);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch { }
  };

  const handleClaim = (e) => {
    e.stopPropagation();
    if (!gift?.claimUrl) return;
    window.open(gift.claimUrl, '_blank', 'noopener');
  };

  return (
    <div className="gift-card-sm gift-card-enter" style={{ animationDelay: `${index * 120}ms` }}>
      <div className={`gift-card-flipper ${flipped ? 'gift-card-flipped' : ''}`}
        onClick={() => !flipped && setFlipped(true)}>

        {/* FRONT — generic gift icon, no brand logo */}
        <div className="gift-card-face gift-card-front" style={{ cursor: flipped ? 'default' : 'pointer' }}>
          <div className="absolute inset-0 rounded-2xl opacity-[0.03]"
            style={{ backgroundImage: 'repeating-linear-gradient(135deg, transparent, transparent 20px, var(--accent-primary) 20px, var(--accent-primary) 21px)' }} />

          <div className="flex flex-col items-center justify-center h-full relative z-10 p-3">
            <div className="w-10 h-10 rounded-full flex items-center justify-center mb-2 gift-icon-float"
              style={{ background: 'linear-gradient(135deg, var(--accent-glow), rgba(233,30,99,0.08))', color: 'var(--accent-primary)', border: '1px solid var(--accent-glow)' }}>
              <Gift size={18} />
            </div>
            <p className="font-heading text-sm sm:text-base mb-0.5" style={{ color: 'var(--text-primary)' }}>
              {gift.label}
            </p>
            <p className="font-body text-[8px]" style={{ color: 'var(--accent-light)', opacity: 0.7 }}>
              Tap to reveal
            </p>
          </div>

          <span className="absolute top-2 right-2 opacity-10" style={{ color: 'var(--accent-primary)' }}>
            <Heart size={8} fill="currentColor" strokeWidth={0} />
          </span>
        </div>

        {/* BACK — brand icon + action */}
        <div className="gift-card-face gift-card-back">
          <div className="flex flex-col items-center justify-center h-full relative z-10 p-3 gap-2">
            {/* Brand icon */}
            <div className="w-10 h-10 rounded-full flex items-center justify-center"
              style={{ backgroundColor: 'var(--accent-glow)', color: gift.color }}>
              <BrandIcon size={22} />
            </div>

            <p className="font-heading text-sm sm:text-base" style={{ color: 'var(--text-primary)' }}>
              {gift.label}
            </p>

            {gift.description && (
              <p className="font-body text-[9px] sm:text-[10px] text-center leading-snug" style={{ color: 'var(--accent-light)', opacity: 0.85 }}>
                {gift.description}
              </p>
            )}

            {/* Claim button (Discord / Spotify) */}
            {gift.claimUrl && (
              <button onClick={handleClaim}
                className="inline-flex items-center gap-1 px-3.5 py-1.5 rounded-full font-body text-[9px] font-medium text-white transition-all duration-200 hover:scale-105 active:scale-95"
                style={{ background: 'linear-gradient(135deg, var(--accent-primary), var(--accent-light))', boxShadow: '0 3px 12px var(--accent-glow)', border: 'none', cursor: 'pointer' }}>
                {gift.claimText} <ExternalLink size={9} />
              </button>
            )}

            {/* Steam code copy */}
            {gift.code && (
              <button onClick={handleCopy}
                className="gift-code-field flex items-center gap-1 px-2.5 py-1.5 rounded-lg font-body text-[8px] transition-all duration-200 hover:scale-105 active:scale-95"
                style={{
                  backgroundColor: 'var(--accent-glow)',
                  border: '1px solid var(--accent-light)',
                  color: copied ? '#22c55e' : 'var(--text-primary)',
                  fontFamily: 'monospace',
                  cursor: 'pointer',
                }}>
                {copied ? <><Check size={9} /> Copied!</> : <><Copy size={9} /> {gift.code}</>}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

/* ─── Large video card (flip to reveal, then play) ─── */
function VideoCard({ gift, index, onVideoPlay, onVideoStop }) {
  const [flipped, setFlipped] = useState(false);
  const [playing, setPlaying] = useState(false);
  const [error, setError] = useState(false);
  const videoRef = useRef(null);

  const handlePlay = (e) => {
    e.stopPropagation();
    if (!gift?.videoSrc) { setError(true); return; }
    setPlaying(true);
    onVideoPlay?.();
    setTimeout(() => {
      try { videoRef.current?.play()?.catch(() => setError(true)); }
      catch { setError(true); }
    }, 50);
  };

  return (
    <div className="gift-card-video gift-card-enter" style={{ animationDelay: `${index * 120}ms` }}>
      <div className={`gift-card-flipper ${flipped ? 'gift-card-flipped' : ''}`}
        onClick={() => !flipped && setFlipped(true)}>

        {/* FRONT */}
        <div className="gift-card-face gift-card-front" style={{ cursor: flipped ? 'default' : 'pointer' }}>
          <div className="absolute inset-0 rounded-2xl opacity-[0.03]"
            style={{ backgroundImage: 'repeating-linear-gradient(135deg, transparent, transparent 20px, var(--accent-primary) 20px, var(--accent-primary) 21px)' }} />

          <div className="absolute inset-0 flex flex-col items-center justify-center gap-2">
            <div className="w-14 h-14 rounded-full flex items-center justify-center gift-icon-float"
              style={{ background: 'linear-gradient(135deg, var(--accent-primary), var(--accent-light))', color: '#fff', boxShadow: '0 4px 20px var(--accent-glow)' }}>
              <Gift size={22} />
            </div>
            <p className="font-heading text-sm sm:text-base" style={{ color: 'var(--text-primary)' }}>
              {gift?.label || 'A Video For You'}
            </p>
            <p className="font-body text-[9px]" style={{ color: 'var(--accent-light)', opacity: 0.7 }}>
              Tap to reveal
            </p>
          </div>

          <span className="absolute top-3 left-3 opacity-10" style={{ color: 'var(--accent-primary)' }}>
            <Sparkles size={12} />
          </span>
          <span className="absolute bottom-3 right-3 opacity-10" style={{ color: 'var(--accent-primary)' }}>
            <Heart size={10} fill="currentColor" strokeWidth={0} />
          </span>
        </div>

        {/* BACK */}
        <div className="gift-card-face gift-card-back">
          {error ? (
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-2 p-4">
              <Heart size={24} style={{ color: 'var(--accent-light)' }} />
              <p className="font-body text-xs" style={{ color: 'var(--text-secondary)' }}>
                Couldn't load the video right now
              </p>
              <button onClick={(e) => { e.stopPropagation(); setError(false); setPlaying(false); }}
                className="px-3 py-1 rounded-full font-body text-[10px] transition-all duration-200 hover:scale-105"
                style={{ border: '1px solid var(--accent-light)', color: 'var(--accent-primary)', background: 'none', cursor: 'pointer' }}>
                Try again
              </button>
            </div>
          ) : !playing ? (
            <button onClick={handlePlay}
              className="absolute inset-0 flex flex-col items-center justify-center gap-2 group"
              style={{ background: 'linear-gradient(135deg, var(--accent-glow), rgba(233,30,99,0.12))', border: 'none', cursor: 'pointer', borderRadius: '1rem' }}>
              <div className="w-14 h-14 rounded-full flex items-center justify-center transition-transform duration-200 group-hover:scale-110"
                style={{ background: 'linear-gradient(135deg, var(--accent-primary), var(--accent-light))', color: '#fff', boxShadow: '0 4px 24px var(--accent-glow)' }}>
                <Play size={22} fill="#fff" strokeWidth={0} />
              </div>
              <span className="font-body text-[10px]" style={{ color: 'var(--text-secondary)' }}>Tap to play</span>
            </button>
          ) : (
            <video ref={videoRef} controls playsInline
              className="absolute inset-0 w-full h-full object-contain rounded-2xl"
              style={{ backgroundColor: '#000' }}
              src={gift?.videoSrc}
              onError={() => setError(true)}
              onPause={() => onVideoStop?.()}
              onEnded={() => onVideoStop?.()}
              onPlay={() => onVideoPlay?.()}
            />
          )}
        </div>
      </div>
    </div>
  );
}

/* ─── Enhanced lily SVG — rich, lush, detailed ─── */
let lilyIdCounter = 0;
function LilySVG({ color, size }) {
  const uid = useState(() => `lily-${++lilyIdCounter}`)[0];
  const isPink = color !== '#fff' && color !== '#FFF5F8' && color !== '#FCE4EC';

  const petalBase = color;
  const petalTip = isPink ? '#F8BBD0' : '#fff';
  const petalDeep = isPink ? '#AD1457' : '#EC407A';
  const petalMid = isPink ? '#E91E63' : '#F8BBD0';
  const petalStroke = isPink ? 'rgba(173,20,87,0.3)' : 'rgba(236,64,122,0.18)';
  const spotColor = isPink ? 'rgba(136,14,79,0.3)' : 'rgba(194,24,91,0.15)';
  const stamenFilament = isPink ? '#7CB342' : '#AED581';
  const antherColor = isPink ? '#E65100' : '#FF8A65';
  const antherHighlight = isPink ? '#FF9800' : '#FFB74D';

  // Ruffled lily petal — organic wavy edges
  const petalPath = 'M0,-5 C-3,-7 -6,-12 -10,-18 C-13,-23 -15,-30 -13,-37 C-11,-42 -8,-46 -5,-48 Q-2,-49 0,-49 Q2,-49 5,-48 C8,-46 11,-42 13,-37 C15,-30 13,-23 10,-18 C6,-12 3,-7 0,-5 Z';
  // Inner petal with slightly different shape
  const innerPath = 'M0,-4 C-2,-6 -7,-14 -8,-24 C-8,-30 -5,-36 -3,-38 Q-1,-39 0,-39 Q1,-39 3,-38 C5,-36 8,-30 8,-24 C7,-14 2,-6 0,-4 Z';

  return (
    <svg width={size} height={size} viewBox="-55 -55 110 110" style={{ overflow: 'visible' }}>
      <defs>
        {/* Multi-stop petal gradient — deep base fading to soft tip */}
        <linearGradient id={`${uid}-pg`} x1="0" y1="0" x2="0" y2="-49" gradientUnits="userSpaceOnUse">
          <stop offset="0%" stopColor={petalDeep} stopOpacity="0.6" />
          <stop offset="25%" stopColor={petalMid} stopOpacity="0.8" />
          <stop offset="55%" stopColor={petalBase} stopOpacity="0.92" />
          <stop offset="85%" stopColor={petalTip} stopOpacity="0.88" />
          <stop offset="100%" stopColor={isPink ? '#FCE4EC' : '#fff'} stopOpacity="0.7" />
        </linearGradient>
        {/* Petal inner shimmer — radial highlight */}
        <radialGradient id={`${uid}-hi`} cx="40%" cy="35%" r="55%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.4)" />
          <stop offset="100%" stopColor="rgba(255,255,255,0)" />
        </radialGradient>
        {/* Center golden glow */}
        <radialGradient id={`${uid}-cg`} cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#FFFDE7" />
          <stop offset="35%" stopColor="#FFF9C4" />
          <stop offset="70%" stopColor={isPink ? '#FFE082' : '#FFF8E1'} />
          <stop offset="100%" stopColor={isPink ? '#FFD54F' : '#FFECB3'} />
        </radialGradient>
        {/* Soft shadow */}
        <filter id={`${uid}-sh`} x="-25%" y="-25%" width="150%" height="150%">
          <feDropShadow dx="0" dy="1.5" stdDeviation="2" floodColor={isPink ? '#C2185B' : '#E91E63'} floodOpacity="0.18" />
        </filter>
        {/* Dewdrop highlight */}
        <radialGradient id={`${uid}-dew`} cx="30%" cy="30%" r="50%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.9)" />
          <stop offset="100%" stopColor="rgba(255,255,255,0.1)" />
        </radialGradient>
      </defs>

      <g filter={`url(#${uid}-sh)`}>
        {/* === 6 outer petals === */}
        {[0, 60, 120, 180, 240, 300].map((angle, i) => (
          <g key={`op${i}`} transform={`rotate(${angle})`}>
            {/* Main petal body */}
            <path d={petalPath} fill={`url(#${uid}-pg)`} stroke={petalStroke} strokeWidth="0.35" />
            {/* Shimmer highlight overlay */}
            <path d={petalPath} fill={`url(#${uid}-hi)`} />
            {/* Center vein — slightly curved */}
            <path d="M0,-7 Q-0.8,-22 -0.3,-38 Q0,-45 0,-48" stroke={petalStroke} strokeWidth="0.45" fill="none" opacity="0.35" />
            {/* Branching veins — left */}
            <path d="M-0.5,-14 Q-4,-20 -7,-28" stroke={petalStroke} strokeWidth="0.2" fill="none" opacity="0.18" />
            <path d="M-0.5,-20 Q-5,-26 -9,-35" stroke={petalStroke} strokeWidth="0.18" fill="none" opacity="0.14" />
            <path d="M-0.3,-26 Q-3,-30 -6,-38" stroke={petalStroke} strokeWidth="0.15" fill="none" opacity="0.12" />
            {/* Branching veins — right */}
            <path d="M0.5,-14 Q4,-20 7,-28" stroke={petalStroke} strokeWidth="0.2" fill="none" opacity="0.18" />
            <path d="M0.5,-20 Q5,-26 9,-35" stroke={petalStroke} strokeWidth="0.18" fill="none" opacity="0.14" />
            <path d="M0.3,-26 Q3,-30 6,-38" stroke={petalStroke} strokeWidth="0.15" fill="none" opacity="0.12" />
            {/* Edge highlight — left side shimmer */}
            <path d="M-2,-9 Q-12,-22 -11,-38 Q-8,-46 -5,-48"
              stroke="rgba(255,255,255,0.3)" strokeWidth="0.7" fill="none" />
            {/* Edge highlight — right side faint */}
            <path d="M2,-9 Q12,-22 11,-38 Q8,-46 5,-48"
              stroke="rgba(255,255,255,0.15)" strokeWidth="0.4" fill="none" />
            {/* Speckled spots — scattered realistically */}
            <circle cx="-3" cy="-15" r="0.9" fill={spotColor} />
            <circle cx="2.5" cy="-14" r="0.7" fill={spotColor} />
            <circle cx="-1" cy="-19" r="1.1" fill={spotColor} />
            <circle cx="3.5" cy="-21" r="0.6" fill={spotColor} />
            <circle cx="-4" cy="-24" r="0.85" fill={spotColor} />
            <circle cx="1" cy="-26" r="0.75" fill={spotColor} />
            <circle cx="-2" cy="-30" r="0.6" fill={spotColor} />
            <circle cx="2" cy="-33" r="0.5" fill={spotColor} />
            <circle cx="-3.5" cy="-35" r="0.4" fill={spotColor} />
            {/* Dewdrop on petal */}
            {i % 2 === 0 && (
              <ellipse cx={i % 3 === 0 ? -2 : 2.5} cy={-20 - (i % 3) * 4} rx="1.4" ry="1.1"
                fill={`url(#${uid}-dew)`} stroke="rgba(255,255,255,0.3)" strokeWidth="0.2" />
            )}
          </g>
        ))}

        {/* === 6 inner petals (offset 30°) === */}
        {[30, 90, 150, 210, 270, 330].map((angle, i) => (
          <g key={`ip${i}`} transform={`rotate(${angle})`}>
            <path d={innerPath} fill={petalBase} stroke={petalStroke} strokeWidth="0.25" opacity="0.5" />
            <path d={innerPath} fill="rgba(255,255,255,0.12)" />
            <path d="M0,-6 Q-0.4,-16 0,-37" stroke={petalStroke} strokeWidth="0.2" fill="none" opacity="0.2" />
            {/* A few spots on inner petals */}
            <circle cx="-1.5" cy="-16" r="0.5" fill={spotColor} opacity="0.6" />
            <circle cx="1" cy="-20" r="0.4" fill={spotColor} opacity="0.5" />
          </g>
        ))}
      </g>

      {/* === Center — golden pistil + stamens === */}
      <g>
        {/* Outer glow ring */}
        <circle cx="0" cy="0" r="10" fill={`url(#${uid}-cg)`} opacity="0.5" />
        {/* Center disc */}
        <circle cx="0" cy="0" r="7.5" fill={`url(#${uid}-cg)`} />
        {/* Textured ring */}
        <circle cx="0" cy="0" r="5.5" fill="none" stroke={isPink ? '#FFD54F' : '#FFE082'} strokeWidth="0.4" opacity="0.5" />
        <circle cx="0" cy="0" r="7" fill="none" stroke={isPink ? '#FFCC80' : '#FFE0B2'} strokeWidth="0.3" opacity="0.3" />

        {/* 6 stamens */}
        {[0, 60, 120, 180, 240, 300].map((angle, i) => {
          const rad = (angle * Math.PI) / 180;
          const dx = Math.cos(rad);
          const dy = Math.sin(rad);
          const cx1 = dx * 9 + dy * 2.5;
          const cy1 = dy * 9 - dx * 2.5;
          const ex = dx * 17;
          const ey = dy * 17;
          return (
            <g key={`st${i}`}>
              {/* Filament */}
              <path d={`M${dx * 4},${dy * 4} Q${cx1},${cy1} ${ex},${ey}`}
                stroke={stamenFilament} strokeWidth="0.65" fill="none" opacity="0.75" />
              {/* Anther — two-toned */}
              <ellipse cx={ex} cy={ey} rx="2.5" ry="1.3" fill={antherColor}
                transform={`rotate(${angle} ${ex} ${ey})`} />
              <ellipse cx={ex} cy={ey} rx="1.8" ry="0.8" fill={antherHighlight}
                transform={`rotate(${angle} ${ex} ${ey})`} opacity="0.6" />
              {/* Pollen specks */}
              <circle cx={ex + dx * 1.2} cy={ey + dy * 1.2} r="0.5" fill="#FFD600" opacity="0.5" />
              <circle cx={ex - dy * 0.8} cy={ey + dx * 0.8} r="0.35" fill="#FFEB3B" opacity="0.4" />
            </g>
          );
        })}

        {/* Central pistil — layered */}
        <circle cx="0" cy="0" r="3.5" fill={isPink ? '#689F38' : '#8BC34A'} opacity="0.5" />
        <circle cx="0" cy="0" r="2" fill={isPink ? '#7CB342' : '#9CCC65'} opacity="0.6" />
        <circle cx="0.5" cy="-0.5" r="0.8" fill="rgba(255,255,255,0.3)" />
      </g>
    </svg>
  );
}

/* ─── Lily bouquet card (flip to reveal flowers) ─── */
const LILY_FLOWERS = [
  // Top row — 3 large blooms (shifted up for wrapping space)
  { left: '50%', top: '15%', size: 200, rotation: 0, color: '#F48FB1', delay: 0 },
  { left: '24%', top: '15%', size: 180, rotation: -24, color: '#fff', delay: 80 },
  { left: '75%', top: '11%', size: 180, rotation: 22, color: '#E91E63', delay: 140 },
  // Upper-mid fills
  { left: '35%', top: '24%', size: 150, rotation: -10, color: '#FFF5F8', delay: 200 },
  { left: '65%', top: '22%', size: 150, rotation: 14, color: '#F48FB1', delay: 240 },
  // Mid row — packed center
  { left: '52%', top: '30%', size: 160, rotation: -5, color: '#fff', delay: 300 },
  { left: '22%', top: '37%', size: 160, rotation: -18, color: '#E91E63', delay: 260 },
  { left: '70%', top: '35%', size: 160, rotation: -18, color: '#E91E63', delay: 260 },
  { left: '78%', top: '35%', size: 160, rotation: 16, color: '#FCE4EC', delay: 280 },
  { left: '29%', top: '35%', size: 160, rotation: 16, color: '#FCE4EC', delay: 280 },
  // Lower-mid fills
  { left: '38%', top: '48%', size: 150, rotation: -8, color: '#F48FB1', delay: 340 },
  { left: '62%', top: '46%', size: 150, rotation: 10, color: '#fff', delay: 360 },
  // Bottom row (just above wrapping)
  { left: '50%', top: '45%', size: 135, rotation: 3, color: '#FFF5F8', delay: 400 },
  { left: '25%', top: '53%', size: 135, rotation: -22, color: '#FCE4EC', delay: 380 },
  { left: '75%', top: '52%', size: 135, rotation: 20, color: '#FCE4EC', delay: 390 },
  // Edge fills
  { left: '8%', top: '26%', size: 75, rotation: -35, color: '#FFF5F8', delay: 180 },
  { left: '92%', top: '24%', size: 78, rotation: 30, color: '#fff', delay: 200 },
  { left: '12%', top: '48%', size: 70, rotation: -28, color: '#F48FB1', delay: 320 },
  { left: '88%', top: '46%', size: 72, rotation: 25, color: '#E91E63', delay: 340 },
];

function LilyCard({ gift, index }) {
  const [flipped, setFlipped] = useState(false);

  return (
    <div className="gift-card-lily gift-card-enter" style={{ animationDelay: `${index * 120}ms` }}>
      <div className={`gift-card-flipper ${flipped ? 'gift-card-flipped' : ''}`}
        onClick={() => !flipped && setFlipped(true)}>

        {/* FRONT */}
        <div className="gift-card-face gift-card-front" style={{ cursor: flipped ? 'default' : 'pointer' }}>
          <div className="absolute inset-0 rounded-2xl opacity-[0.03]"
            style={{ backgroundImage: 'repeating-linear-gradient(135deg, transparent, transparent 20px, var(--accent-primary) 20px, var(--accent-primary) 21px)' }} />
          <div className="absolute inset-0 flex flex-col items-center justify-center gap-2">
            <div className="w-14 h-14 rounded-full flex items-center justify-center gift-icon-float"
              style={{ background: 'linear-gradient(135deg, #F48FB1, #FCE4EC)', color: '#C2185B', boxShadow: '0 4px 20px rgba(244,143,177,0.3)' }}>
              <Heart size={22} fill="#C2185B" strokeWidth={0} />
            </div>
            <p className="font-heading text-sm sm:text-base" style={{ color: 'var(--text-primary)' }}>
              {gift?.label || 'Lilies For You'}
            </p>
            <p className="font-body text-[9px]" style={{ color: 'var(--accent-light)', opacity: 0.7 }}>
              Tap to reveal
            </p>
          </div>
          <span className="absolute top-3 left-3 opacity-10" style={{ color: 'var(--accent-primary)' }}>
            <Sparkles size={12} />
          </span>
          <span className="absolute bottom-3 right-3 opacity-10" style={{ color: 'var(--accent-primary)' }}>
            <Heart size={10} fill="currentColor" strokeWidth={0} />
          </span>
        </div>

        {/* BACK — lily bouquet */}
        <div className="gift-card-face gift-card-back lily-card-back">
          <div className="absolute inset-0 overflow-hidden rounded-2xl">
            {/* Radial glow */}
            <div className="lily-card-glow" />

            {/* Bouquet SVG — stems + wrapping paper + ribbon */}
            <svg className="lily-stems-svg" viewBox="0 0 300 300" preserveAspectRatio="xMidYMid meet">
              <defs>
                {/* Wrapping paper gradient — soft pink kraft */}
                <linearGradient id="wrap-grad" x1="0" y1="0" x2="1" y2="1">
                  <stop offset="0%" stopColor="#FBDAE5" />
                  <stop offset="30%" stopColor="#F8BBD0" />
                  <stop offset="60%" stopColor="#F48FB1" />
                  <stop offset="100%" stopColor="#EC407A" />
                </linearGradient>
                {/* Inner tissue paper */}
                <linearGradient id="tissue-grad" x1="0.5" y1="0" x2="0.5" y2="1">
                  <stop offset="0%" stopColor="#FFF5F8" />
                  <stop offset="100%" stopColor="#FCE4EC" />
                </linearGradient>
                {/* Ribbon gradient */}
                <linearGradient id="ribbon-grad" x1="0" y1="0" x2="1" y2="0">
                  <stop offset="0%" stopColor="#AD1457" />
                  <stop offset="40%" stopColor="#D81B60" />
                  <stop offset="60%" stopColor="#E91E63" />
                  <stop offset="100%" stopColor="#AD1457" />
                </linearGradient>
                {/* Wrapping paper pattern — subtle diagonal lines */}
                <pattern id="wrap-pattern" x="0" y="0" width="12" height="12" patternUnits="userSpaceOnUse" patternTransform="rotate(30)">
                  <line x1="0" y1="0" x2="0" y2="12" stroke="#fff" strokeWidth="0.5" opacity="0.12" />
                </pattern>
              </defs>

              {/* Stems — extend from gathering point upward */}
              <path d="M150 210 Q149 180 148 150 Q147 110 150 40" stroke="#81C784" strokeWidth="2.5" fill="none" opacity="0.45" />
              <path d="M150 210 Q130 180 105 150 Q85 115 68 60" stroke="#81C784" strokeWidth="2" fill="none" opacity="0.4" />
              <path d="M150 210 Q135 190 115 165 Q95 140 42 115" stroke="#A5D6A7" strokeWidth="1.5" fill="none" opacity="0.3" />
              <path d="M150 210 Q170 178 198 145 Q218 110 235 55" stroke="#81C784" strokeWidth="2" fill="none" opacity="0.4" />
              <path d="M150 210 Q168 185 190 160 Q210 135 258 110" stroke="#A5D6A7" strokeWidth="1.5" fill="none" opacity="0.3" />
              {/* Leaves */}
              <ellipse cx="120" cy="175" rx="16" ry="5" fill="#81C784" opacity="0.3" transform="rotate(-40 120 175)" />
              <ellipse cx="185" cy="170" rx="16" ry="5" fill="#81C784" opacity="0.3" transform="rotate(35 185 170)" />
              <ellipse cx="95" cy="140" rx="12" ry="4" fill="#A5D6A7" opacity="0.25" transform="rotate(-50 95 140)" />
              <ellipse cx="210" cy="135" rx="12" ry="4" fill="#A5D6A7" opacity="0.25" transform="rotate(45 210 135)" />

              {/* ── Wrapping paper cone ── */}
              {/* Main wrapper — solid cone: wide top, narrow bottom */}
              <path d="M42 185 Q150 178 258 185 L150 305 Z"
                fill="url(#wrap-grad)" />
              {/* Paper texture overlay */}
              <path d="M42 185 Q150 178 258 185 L150 305 Z"
                fill="url(#wrap-pattern)" />
              {/* Left fold crease */}
              <path d="M75 184 L150 305" stroke="#fff" strokeWidth="1" opacity="0.15" />
              {/* Right fold crease */}
              <path d="M225 184 L150 305" stroke="#000" strokeWidth="0.8" opacity="0.06" />
              {/* Center fold — subtle depth */}
              <path d="M150 180 L150 305" stroke="#000" strokeWidth="0.5" opacity="0.04" />
              {/* Paper edge highlight (top edge) */}
              <path d="M42 185 Q150 178 258 185" stroke="#fff" strokeWidth="0.8" fill="none" opacity="0.25" />

              {/* Tissue paper peeking out from top of wrapping */}
              {/* Left tissue ruffle */}
              <path d="M52 186 Q60 170 72 174 Q82 164 92 172 Q100 160 112 170"
                fill="url(#tissue-grad)" stroke="#FCE4EC" strokeWidth="0.5" opacity="0.85" />
              {/* Center tissue ruffle */}
              <path d="M112 170 Q125 158 140 166 Q150 154 160 166 Q175 158 188 170"
                fill="url(#tissue-grad)" stroke="#FCE4EC" strokeWidth="0.5" opacity="0.85" />
              {/* Right tissue ruffle */}
              <path d="M188 170 Q200 160 210 172 Q218 164 228 174 Q238 170 248 186"
                fill="url(#tissue-grad)" stroke="#FCE4EC" strokeWidth="0.5" opacity="0.85" />

              {/* ── Ribbon tie at gathering point ── */}
              {/* Ribbon band */}
              <path d="M72 196 Q110 192 150 191 Q190 192 228 196"
                stroke="url(#ribbon-grad)" strokeWidth="5" fill="none" strokeLinecap="round" />
              {/* Ribbon shine */}
              <path d="M90 194 Q120 191 150 190 Q180 191 210 194"
                stroke="#fff" strokeWidth="1" fill="none" opacity="0.25" />

              {/* Ribbon bow — left loop */}
              <path d="M150 191 Q130 175 118 182 Q112 188 125 193 Q135 196 150 191 Z"
                fill="url(#ribbon-grad)" opacity="0.9" />
              <path d="M150 191 Q135 180 126 184" stroke="#fff" strokeWidth="0.6" fill="none" opacity="0.3" />
              {/* Ribbon bow — right loop */}
              <path d="M150 191 Q170 175 182 182 Q188 188 175 193 Q165 196 150 191 Z"
                fill="url(#ribbon-grad)" opacity="0.9" />
              <path d="M150 191 Q165 180 174 184" stroke="#fff" strokeWidth="0.6" fill="none" opacity="0.3" />
              {/* Bow center knot */}
              <ellipse cx="150" cy="191" rx="5" ry="3.5" fill="#C2185B" />
              <ellipse cx="150" cy="190" rx="3" ry="2" fill="#E91E63" opacity="0.6" />
              {/* Ribbon tails */}
              <path d="M150 194 Q140 210 128 225 Q124 230 120 228" stroke="url(#ribbon-grad)" strokeWidth="2.5" fill="none" strokeLinecap="round" />
              <path d="M150 194 Q160 210 172 225 Q176 230 180 228" stroke="url(#ribbon-grad)" strokeWidth="2.5" fill="none" strokeLinecap="round" />
              {/* Tail shine */}
              <path d="M148 196 Q140 210 130 222" stroke="#fff" strokeWidth="0.5" fill="none" opacity="0.2" />
              <path d="M152 196 Q160 210 170 222" stroke="#fff" strokeWidth="0.5" fill="none" opacity="0.2" />
            </svg>

            {/* Flowers — positioned with CSS, wind sway via CSS vars */}
            {LILY_FLOWERS.map((f, i) => {
              // Seeded pseudo-random per flower for consistent wind feel
              const s = i * 137.508;
              const r = (n) => Math.sin(s + n * 97.3) * 2 + Math.cos(s + n * 53.7) * 1.5;
              const windDur = 3.5 + (i % 5) * 0.6; // 3.5s–6.5s staggered
              const windDelay = 0.8 + f.delay / 1000 + (i % 3) * 0.3;
              return (
                <div key={i} className="lily-bloom-wrapper"
                  style={{
                    position: 'absolute',
                    left: f.left,
                    top: f.top,
                    '--r': `${f.rotation}deg`,
                    animationDelay: `${f.delay}ms, ${windDelay}s`,
                    '--wind-dur': `${windDur}s`,
                    '--wx1': `${r(1).toFixed(1)}px`, '--wy1': `${(r(2) * 0.6).toFixed(1)}px`, '--ws1': `${(r(3) * 1.5).toFixed(1)}deg`,
                    '--wx2': `${(r(4) * -1).toFixed(1)}px`, '--wy2': `${(r(5) * 0.8).toFixed(1)}px`, '--ws2': `${(r(6) * 1.2).toFixed(1)}deg`,
                    '--wx3': `${(r(7) * 1.3).toFixed(1)}px`, '--wy3': `${(r(8) * -0.7).toFixed(1)}px`, '--ws3': `${(r(9) * 1.8).toFixed(1)}deg`,
                    '--wx4': `${(r(10) * -0.9).toFixed(1)}px`, '--wy4': `${(r(11) * 0.5).toFixed(1)}px`, '--ws4': `${(r(12) * 1).toFixed(1)}deg`,
                    '--wx5': `${(r(13) * 0.7).toFixed(1)}px`, '--wy5': `${(r(14) * -0.4).toFixed(1)}px`, '--ws5': `${(r(15) * 0.8).toFixed(1)}deg`,
                    zIndex: 2,
                  }}>
                  <LilySVG color={f.color} size={f.size} />
                </div>
              );
            })}

            {/* Sparkle accents */}
            {[
              { left: '10%', top: '14%', size: 14, delay: 0 },
              { left: '90%', top: '12%', size: 11, delay: 600 },
              { left: '6%', top: '55%', size: 9, delay: 1200 },
              { left: '94%', top: '55%', size: 10, delay: 1800 },
              { left: '50%', top: '5%', size: 8, delay: 400 },
            ].map((s, i) => (
              <span key={i} className="lily-sparkle-accent"
                style={{
                  position: 'absolute', left: s.left, top: s.top,
                  fontSize: s.size, animationDelay: `${s.delay}ms`,
                  color: 'var(--accent-primary)', pointerEvents: 'none',
                }}>
                &#10022;
              </span>
            ))}

            {/* Label */}
            <div className="absolute lily-card-label"
              style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
              <span className="font-cursive text-sm" style={{
                color: 'var(--accent-primary)',
                background: 'rgba(255, 245, 248, 0.85)',
                backdropFilter: 'blur(4px)',
                padding: '4px 14px',
                borderRadius: '999px',
                whiteSpace: 'nowrap',
                maxWidth: '90vw',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                boxShadow: '0 1px 6px rgba(233, 30, 99, 0.12)',
                border: '1px solid rgba(244, 143, 177, 0.25)',
              }}>
                {gift?.lilyLabel || 'just for you'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ─── Main component ─── */
export default function MiniSurprise({ onVideoPlay, onVideoStop }) {
  const [phase, setPhase] = useState('wrapped');
  const [sparkles, setSparkles] = useState([]);
  let sparkId = 0;

  const burstConfetti = useCallback(() => {
    const colors = ['#E91E63', '#F48FB1', '#FF80AB', '#FCE4EC', '#CE93D8', '#fff'];
    confetti({ particleCount: 50, spread: 80, origin: { y: 0.6 }, colors });
    setTimeout(() => confetti({ particleCount: 30, spread: 60, origin: { y: 0.65 }, colors }), 200);
    setTimeout(() => confetti({ particleCount: 20, spread: 100, origin: { y: 0.55 }, colors }), 400);
  }, []);

  const spawnSparkles = () => {
    const newSp = Array.from({ length: 8 }, () => ({
      id: ++sparkId, x: 30 + Math.random() * 40, y: 20 + Math.random() * 60,
      size: Math.random() * 10 + 6, delay: Math.random() * 400,
    }));
    setSparkles(newSp);
    setTimeout(() => setSparkles([]), 1000);
  };

  const handleOpen = () => {
    if (phase !== 'wrapped') return;
    setPhase('shaking');
    setTimeout(() => {
      setPhase('unwrapping'); spawnSparkles();
      setTimeout(() => { setPhase('opened'); burstConfetti(); }, 800);
    }, 600);
  };

  const gifts = SURPRISE?.gifts || [];
  const smallGifts = gifts.filter(g => g?.id !== 'video' && g?.id !== 'lilies');
  const videoGift = gifts.find(g => g?.id === 'video');
  const lilyGift = gifts.find(g => g?.id === 'lilies');

  return (
    <section id="mini-surprise" data-testid="mini-surprise-section" className="section-romantic text-center">
      <div className="max-w-2xl mx-auto px-4">
        <div className="mb-3">
          <p className="font-body text-[10px] tracking-widest uppercase mb-2" style={{ color: 'var(--accent-light)' }}>{SURPRISE.sectionLabel}</p>
          <h2 className="font-heading text-2xl md:text-3xl mb-2" style={{ color: 'var(--text-primary)' }}>{SURPRISE.heading}</h2>
        </div>

        <div className="relative" style={{ minHeight: 280 }}>
          {sparkles.map(s => (
            <span key={s.id} className="surprise-sparkle"
              style={{ left: `${s.x}%`, top: `${s.y}%`, fontSize: s.size, animationDelay: `${s.delay}ms`, color: 'var(--accent-primary)' }}>&#10022;</span>
          ))}

          {phase !== 'opened' ? (
            <div className="flex justify-center">
              <button data-testid="gift-box-btn" onClick={handleOpen}
                className={`surprise-gift-wrapper ${phase === 'shaking' ? 'surprise-shake-intense' : phase === 'unwrapping' ? 'surprise-unwrap' : ''}`}
                style={{ background: 'none', border: 'none', cursor: phase === 'wrapped' ? 'pointer' : 'default' }}>
                <div className="surprise-box">
                  <div className={`surprise-lid ${phase === 'unwrapping' ? 'surprise-lid-open' : ''}`} style={{ backgroundColor: 'var(--accent-primary)' }}>
                    <div className="surprise-ribbon-top" style={{ backgroundColor: 'var(--accent-light)' }} />
                    <div className="surprise-bow">
                      <div className="surprise-bow-loop surprise-bow-left" style={{ borderColor: 'var(--accent-light)' }} />
                      <div className="surprise-bow-loop surprise-bow-right" style={{ borderColor: 'var(--accent-light)' }} />
                      <div className="surprise-bow-center" style={{ backgroundColor: 'var(--accent-light)' }} />
                    </div>
                  </div>
                  <div className="surprise-box-body" style={{ backgroundColor: 'var(--accent-primary)', opacity: 0.85 }}>
                    <div className="surprise-ribbon-v" style={{ backgroundColor: 'var(--accent-light)' }} />
                    <div className="surprise-ribbon-h" style={{ backgroundColor: 'var(--accent-light)' }} />
                    <div className="surprise-box-shine" />
                  </div>
                  <div className="surprise-box-shadow" />
                </div>
                {phase === 'wrapped' && <span className="block mt-5 font-body text-xs" style={{ color: 'var(--text-secondary)' }}>{SURPRISE.tapHint}</span>}
              </button>
            </div>
          ) : (
            <div className="surprise-reveal-card" data-testid="gift-revealed">
              {/* 3 small flip cards in a row */}
              <div className="grid grid-cols-3 gap-2.5 sm:gap-3 mb-3">
                {smallGifts.map((gift, i) => (
                  <SmallGiftCard key={gift.id} gift={gift} index={i} />
                ))}
              </div>

              {/* Big cards below */}
              {videoGift && <VideoCard gift={videoGift} index={smallGifts.length} onVideoPlay={onVideoPlay} onVideoStop={onVideoStop} />}
              {lilyGift && <LilyCard gift={lilyGift} index={smallGifts.length + 1} />}

              <p className="font-body text-[10px] mt-5" style={{ color: 'var(--accent-light)', opacity: 0.5 }}>
                From {MY_NAME}, with love
              </p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
